import React from "react";
import SubscriptionRow from "../../../../components/subscriptionRow";
import useListDas from "./useListDas";
import { IDasSubscription } from "../../../../common/types/dasTypes";

const ListDas = () => {
  const { dasSubscriptionsData, activeAccordion, toggleAccordion } =
    useListDas();
  return dasSubscriptionsData?.length === 0 ? (
    <div>No Alert Subscriptions available.</div>
  ) : (
    <>
      {dasSubscriptionsData?.map((item: IDasSubscription, index: number) => (
        <SubscriptionRow
          key={index}
          item={item}
          index={index}
          isActive={activeAccordion === index}
          toggleAccordion={toggleAccordion}
        />
      ))}
    </>
  );
};

export default ListDas;
